import React from 'react';
import PropTypes from 'prop-types';
import './Popup.css';

function PopupTitle({ label }) {
  return (
    <div className={`popupv2-title`}>{label}</div>
  )
}

PopupTitle.propTypes = {
  label: PropTypes.string.isRequired
}

export default PopupTitle;
